<template>
        <Breadcrumb>
            <Breadcrumb-item >首页</Breadcrumb-item>
            <Breadcrumb-item v-if="breadcrumb.name" :to="breadcrumb.link">{{breadcrumb.name}}</Breadcrumb-item>
            <template  v-if="breadcrumb.item">
                <Breadcrumb-item :to="breadcrumb.item.link">{{breadcrumb.item.name}}</Breadcrumb-item>
                <template v-if="breadcrumb.item.item">
                <Breadcrumb-item  :to="breadcrumb.item.item.link">{{breadcrumb.item.item.name}}</Breadcrumb-item>
                </template>  
            </template> 
          
        </Breadcrumb>
</template>
<script>
import { mapState, mapGetters } from "vuex";
// import menudata from "../../leftMenu.js";
export default {
  data() {
    return {
      breadcrumb: {
      },
      link:"/home",
      
    };
  },
  computed: {
    ...mapState({
      menudata: state => state.menudata,
      activiId:state=>state.activiId
    }),
    ...mapGetters([
      "GETmenudata"
      // ...
    ])
  },
  watch: {
    path: function() {
      this.setbreadcrumb();
    }
  },
  props: {
    path: String
  },
  methods: {
    setbreadcrumb() {
      let _this = this;
      if(this.path=='home'){
        this.breadcrumb={}
      }
      //名字不定 路由不定 、只能通过遍历全部数组匹配
      var path = this.path.replace("/","");
      this.menudata.forEach(element => {
        if (element.id == this.activiId) {
          this.breadcrumb = {
            name: element.name,
            link: '/'
          };
        }
        if (element.submenu && element.submenu.length > 0) {
          element.submenu.forEach(item => {
            if (item.id == this.activiId) {
              this.breadcrumb = {
                name: element.name,
                link: element.link,
                item: {
                  name: item.name,
                  link: item.link
                }
              };
            }
            if (item.submenu && item.submenu.length > 0) {
              item.submenu.forEach(value => {
                if (value.id == this.activiId) {
                  this.breadcrumb = {
                    name: element.name,
                    link: element.link,
                    item: {
                      name: item.name,
                      link: item.link,
                      item: {
                        name: value.name,
                        link: value.link
                      }
                    }
                  };
                }
              });
            }
          });
        }

        //  if(element.name==_this.name&&element.path==_this.path){
        //    //在第一级
        //    _this.breadcrumb={
        //      name:_this.name,
        //      path:_this.path;
        //    }
        //  }
      });
      debugger
    }
  },
  mounted() {
    debugger
      if(this.$route&&this.$route.path){
        this.path=this.$route.path;
         this.setbreadcrumb();
      }
  }
};
</script>

 
       



// WEBPACK FOOTER //
// src/pages/tool/ebreadcrumb.vue